module.exports = __webpack_public_path__ + "img/1991_L.4b3b5302.png";